import Box from '@mui/material/Box';
import { memo, type ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * モバイルビューコンポーネント - 入力エリアのみのタッチフレンドリーなレイアウト
 * PDFプレビューは全画面ドロワーで表示されます
 */
export const MobileView = memo((): ReactElement => {
  // モバイル時はPDFプレビューエリアを除外し、入力エリアのみ表示
  return (
    <Box
      sx={{
        marginTop: { xs: 2, sm: 3 },
        paddingY: { xs: 2, sm: 3 },
        paddingX: { xs: 1, sm: 2 },
        minHeight: 'calc(100vh - 120px)',
        width: '100%',

        // タッチスクロールの最適化
        WebkitOverflowScrolling: 'touch',

        // セーフエリア対応
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'max(8px, env(safe-area-inset-left))',
        paddingRight: 'max(8px, env(safe-area-inset-right))',
      }}
    >
      <Outlet />
    </Box>
  );
});

MobileView.displayName = 'MobileView';
